// extracted by mini-css-extract-plugin
export default {"rating":"pH-z","numberOfStars":"qH-z","count":"rH-z","barGraphSpacing":"sH-z","barGraph":"tH-z"};